























import { Component, Prop, PropSync, Vue } from "vue-property-decorator";
import Treeselect from "@riophae/vue-treeselect";
import { ITaxBusinessType } from "@/models/tax";
import { IState } from "@/store";
import { mapState } from "vuex";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

@Component({
  components: {
    Treeselect
  },
  computed: {
    ...mapState({
      taxBusinessTypes: (state: IState) => state.constants.taxBusinessTypes
    })
  }
})
export default class TaxBusinessTypesList extends Vue {
  // Props
  @Prop({ default: false })
  public disabled!: boolean[];

  @PropSync("businessTypes", { required: true })
  public taxBusinessTypesSynced!: ITaxBusinessType[];

  // Data
  public isLoading = false;
  public taxBusinessTypes!: ITaxBusinessType[];
  public value: number[] = [];

  // Lifecycle methods
  public async created() {
    this.loadData();
  }

  // Getters
  public get taxBusinessTypesIds() {
    return this.taxBusinessTypesSynced.map(i => i.id);
  }

  public get options() {
    return [
      {
        id: 0,
        label: this.$t("_.all"),
        children: this.taxBusinessTypes.map(type => {
          return {
            id: type.id,
            label: type.name
          };
        })
      }
    ];
  }

  // Methods
  public onInput(selectedIds: string[]) {
    const selected = this.taxBusinessTypes.filter(i =>
      selectedIds.includes(i.id)
    );
    this.taxBusinessTypesSynced = selected;
  }

  public async loadData() {
    try {
      this.isLoading = true;
      await this.$store.dispatch("constants/getTaxBusinessTypes");
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
    } finally {
      this.isLoading = false;
    }
  }
}
